import React from 'react'
import * as S from './style'

const Submit = ({ disabled, textWhenDisabled, textWhenEnabled, height}) => (
  <S.Button
    type="submit"
    value={disabled ? textWhenDisabled : textWhenEnabled}
    disabled={disabled}
    height={height}
    data-testid='submit-button-test-id'
  />
)

export default Submit
